<div class="fs-2 with-close" mat-dialog-title>
    Nouvelle vidéo Youtube
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p>
        Gérer un bien immobilier, c’est un vrai métier.<br/>
        <br/>
        Cela ne veut pas dire que vous ne pouvez pas le faire vous-même avec les bonnes méthodes et les bons outils.<br/>
        <br/>
        Passer par un professionnel est également une bonne idée, mais attention à bien le sélectionner !<br/>
        <br/>
        💎 30 jours offerts sur votre gestion locative : <a href="https://bit.ly/3WuSmAW">https://bit.ly/3WuSmAW</a><br/>
        <br/>
        👉 L'analyse complète en vidéo :
    </p>
    <a href="https://youtu.be/c_DRz9ZhvMY" target="_blank">
        <img class="w-100" src="assets/video-yt.jpeg" alt="Gestion locative par Huissier, Agence ou avec un logiciel ?" />
    </a>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn w-100 btn-outline">
        Fermer
    </button>
<!--    <button type="button" (click)="onYesClick()" class="btn btn-primary">-->
<!--        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>-->
<!--        <ng-container *ngIf="!loading">Envoyer</ng-container>-->
<!--    </button>-->
</div>
